import { ShieldCheck, BadgeCheck, FileCheck2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CREDS = [
  "Gas Safe registered engineers on every gas job",
  "Fully insured — public liability cover as standard",
  "Manufacturer-approved installation methods",
  "Landlord Gas Safety (CP12) certificates issued",
];

export const GasSafe = () => (
  <section data-testid="gas-safe-hub" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <Reveal>
          <Eyebrow>Safety first</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight">
            Gas Safe <span className="flame-text">registered</span>
          </h2>
          <p className="mt-4 max-w-md text-lg text-zinc-400 leading-relaxed">
            Working on gas appliances legally requires Gas Safe registration. Every
            engineer we send is qualified, insured and works strictly to regulation —
            so your family and home are always protected.
          </p>
          <ul className="mt-8 space-y-4">
            {CREDS.map((c) => (
              <li key={c} className="flex items-start gap-3">
                <BadgeCheck className="mt-0.5 h-5 w-5 shrink-0 text-[#f5641e]" />
                <span className="text-zinc-300">{c}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-[#1a1a22] to-[#121217] p-8 sm:p-10">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFD700]">
                  <ShieldCheck className="h-7 w-7 text-[#0a0a0c]" />
                </div>
                <div>
                  <div className="font-display text-lg font-bold leading-tight">GAS SAFE</div>
                  <div className="font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">Register</div>
                </div>
              </div>
              <FileCheck2 className="h-6 w-6 text-zinc-600" />
            </div>
            <div className="mt-8 hairline pt-6">
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <div className="font-display text-3xl font-extrabold flame-text">100%</div>
                  <div className="mt-1 font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">Compliant work</div>
                </div>
                <div>
                  <div className="font-display text-3xl font-extrabold flame-text">Fully</div>
                  <div className="mt-1 font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">Insured & qualified</div>
                </div>
              </div>
            </div>
            <p className="mt-8 text-sm text-zinc-500 leading-relaxed">
              Always ask any heating engineer for their Gas Safe ID card — we're happy
              to show ours before we start work.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
